import { z } from 'zod';

const StudioSettingsSchema = z.object({
  showRulers: z.boolean(),
});

const getStorageKey = (designId: string) => `studio:${designId}:settings`;

export const loadShowRulers = (designId: string): boolean => {
  try {
    const stored = localStorage.getItem(getStorageKey(designId));
    if (!stored) return true;
    const result = StudioSettingsSchema.safeParse(JSON.parse(stored));
    return result.success ? result.data.showRulers : true;
  } catch (error) {
    console.error('Failed to load studio settings:', error);
    return true;
  }
};

export const saveShowRulers = (designId: string, showRulers: boolean): void => {
  try {
    localStorage.setItem(getStorageKey(designId), JSON.stringify({ showRulers }));
  } catch (error) {
    console.error('Failed to save studio settings:', error);
  }
};
